import { Winner } from "../../types";
import WinnerAvatar from "../winner/WinnerAvatar";

function CustomTooltip({
  winners,
  active,
  payload,
  label,
}: {
  winners: Winner[];
  active?: boolean;
  payload?: object[];
  label?: string;
}) {
  if (!active || !payload || !payload.length) return null;

  return (
    <div className="us-elections-widget__graph-tooltip">
      <p>{label}</p>
      <ul>
        {payload.map((item: any) => {
          const winner = winners.find((winner) => winner.winner === item.name);
          if (!winner) return null;
          return (
            <li key={winner.winner}>
              <WinnerAvatar
                name={winner.winner}
                winnerColor={winner.winnerColor}
                style={{
                  width: "14px",
                  height: "14px",
                }}
              />
              <p>{winner.winner}</p>
              <p>{item.value.toFixed(1)}%</p>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default CustomTooltip;
